import { jsPDF } from 'jspdf';

const ink = [37, 44, 34];
const muted = [105, 112, 98];
const money = value => new Intl.NumberFormat('en-IE', { style: 'currency', currency: 'EUR' }).format(Number(value || 0));

// The document builder accepts image data so it is also testable outside a browser.
export function createBuildPdf({ items, bikeImage, logo, buildUrl, offer, date = new Date() }) {
  const doc = new jsPDF({ unit: 'mm', format: 'a4', compress: true });
  const total = items.reduce((sum, item) => sum + Number(item.price || 0), 0);
  const title = items.length ? items[0].name : 'Your bike';
  doc.setProperties({ title: `${title} | Velodrom build`, author: 'Velodrom', subject: 'Bicycle specification and indicative pricing' });
  function text(value, x, y, size = 10, color = ink, options = {}) {
    doc.setFont('helvetica', 'normal'); doc.setFontSize(size); doc.setTextColor(...color);
    doc.text(String(value), x, y, options);
  }
  function header(label) {
    doc.setFillColor(246, 245, 241); doc.rect(0, 0, 210, 297, 'F');
    const image = doc.getImageProperties(logo);
    doc.addImage(logo, 'PNG', 18, 16, 48, 48 * image.height / image.width);
    text(label, 192, 23, 8, muted, { align: 'right' });
    doc.setDrawColor(205, 209, 197); doc.line(18, 35, 192, 35);
  }
  function footer(page) {
    doc.setDrawColor(205, 209, 197); doc.line(18, 278, 192, 278);
    text('VELODROM  /  YOUR NEXT RIDE', 18, 286, 8, muted);
    text(String(page).padStart(2, '0'), 192, 286, 8, muted, { align: 'right' });
    doc.link(18, 281, 65, 8, { url: 'https://www.velodrom.cc/' });
  }
  header('PERSONAL BUILD');
  text('BUILT AROUND YOU', 18, 49, 9, muted);
  doc.setFontSize(24);
  const titleLines = doc.splitTextToSize(title, 174);
  text(titleLines.join('\n'), 18, 63, 24);
  const titleBottom = 63 + (titleLines.length - 1) * 10;
  const image = doc.getImageProperties(bikeImage);
  const width = Math.min(174, Math.max(40, 185 - titleBottom) * image.width / image.height);
  const height = width * image.height / image.width;
  doc.addImage(bikeImage, 'PNG', (210 - width) / 2, titleBottom + 10, width, height);
  text(`${items.length} selected components`, 18, 203, 10, muted);
  text('COMPONENT TOTAL', 18, 216, 8, muted);
  text(money(total), 18, 231, 26);
  if (offer != null && Number(offer) > 0) text(`Special build price: ${money(offer)}`, 18, 241, 11);
  text('Indicative pricing. Final price, availability and fit confirmed by Velodrom.', 18, 251, 9, muted);
  text('Contact us for a quote at velodrom.cc', 18, 263, 11);
  doc.link(18, 257, 110, 9, { url: 'https://www.velodrom.cc/pages/contact' });
  footer(1);
  doc.addPage(); header('BUILD SPECIFICATION');
  text('Your build, in detail.', 18, 51, 22);
  text(date.toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' }), 192, 51, 9, muted, { align: 'right' });
  let y = 66, page = 2;
  items.forEach((item, index) => {
    doc.setFontSize(11);
    const lines = doc.splitTextToSize(item.name, 118);
    const rowHeight = Math.max(22, lines.length * 5 + 15);
    if (y + rowHeight > 245) { footer(page++); doc.addPage(); header('BUILD SPECIFICATION / CONTINUED'); y = 49; }
    text(String(index + 1).padStart(2, '0'), 18, y + 3, 8, muted);
    text(item.type.toUpperCase(), 30, y + 3, 8, muted);
    text(lines.join('\n'), 30, y + 10, 11);
    const finish = [item.colorName, item.pair ? `Pair / 2 included / ${money(item.unitPrice)} each` : null].filter(Boolean).join('  /  ');
    text(finish, 30, y + 12 + lines.length * 5, 8, muted);
    text(money(item.price), 192, y + 10, 11, ink, { align: 'right' });
    y += rowHeight; doc.setDrawColor(222, 223, 215); doc.line(18, y - 2, 192, y - 2);
  });
  if (y > 231) { footer(page++); doc.addPage(); header('BUILD SUMMARY'); y = 49; }
  text('Component total', 18, y + 12, 11); text(money(total), 192, y + 12, 17, ink, { align: 'right' });
  text('Reopen and customise this build', 18, y + 28, 10);
  doc.link(18, y + 23, 100, 8, { url: buildUrl });
  text('Prices are indicative; contact Velodrom for your final quote.', 18, y + 40, 8, muted);
  footer(page);
  return doc;
}
